"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var BestLink = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "BestLink",
  componentId: "fj1ebe-0"
})(["&&&{&:hover{cursor:pointer;color:", ";}}"], function (props) {
  return props.theme["mlb-blue"];
});
var _default = BestLink;
exports["default"] = _default;